<template>
  <div id="home" v-swipeup="(e) => vueTouch('上滑', e)">
    <img src="@/assets/1/bg1.jpg" class="bgImg animated fadeIn" v-if="bg" />
    <img src="@/assets/1/bg2.jpg" class="bgImg animated fadeIn" v-if="!bg" />
    <img
      src="@/assets/1/xing.png"
      class="bgImg xing animated fadeIn"
      v-if="xing"
    />
    <img
      src="@/assets/1/xing.png"
      class="bgImg xing animated fadeIn"
      v-if="!xing"
    />

    <div class="icon-div">
      <img src="@/assets/1/icon1.png" class="icon" v-if="icon" />
      <img src="@/assets/1/icon2.png" class="icon" v-if="!icon" />
    </div>
    <!-- logo -->
    <img src="@/assets/1/logo.png" class="logo" />
    <!-- <div v-if="icon" class="icon">
      <img src="@/assets/1/icon1.png" />
    </div> -->
    <!--流星-->
    <div class="liuxing">
      <div class="lx lx1"></div>
      <div class="lx" v-show="lx2State" :class="{ lx2: lx2State }"></div>
      <div class="lx" v-show="lx3State" :class="{ lx3: lx3State }"></div>
      <div class="lx" v-show="lx4State" :class="{ lx4: lx4State }"></div>
      <div class="lx" v-show="lx5State" :class="{ lx5: lx5State }"></div>
      <div class="lx" v-show="lx6State" :class="{ lx6: lx6State }"></div>
    </div>
    <!-- 文字1 -->
    <!-- <div id="text1" v-show="text1">
      <div class="show-text text1 animated fadeIn" v-show="show1">
        <img src="@/assets/1/1-_03.png" />
      </div>
    </div> -->
    <div v-show="text1">
      <transition name="fade">
        <div class="top-img" v-show="showImg">
          <img src="@/assets/1/top.png" class="animated zoomIn" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text text1" v-show="show1">
          <img src="@/assets/1/1-_03.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text text2" v-show="show2">
          <img src="@/assets/1/1-_05.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text text3" v-show="show3">
          <img src="@/assets/1/1-_07.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text text4" v-show="show4">
          <img src="@/assets/1/1-_08.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text text5" v-show="show5">
          <img src="@/assets/1/1-_09.png" />
        </div>
      </transition>
    </div>
    <!-- 文字2 -->
    <div v-show="text2">
      <img
        src="@/assets/2/kuang.png"
        class="kuang animated fadeIn"
        v-if="kuang"
      />
      <transition name="fade">
        <div class="show-text2 text6" v-show="show6">
          <img src="@/assets/2/text1.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text2 text7" v-show="show7">
          <img src="@/assets/2/text2.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text2 text8" v-show="show8">
          <img src="@/assets/2/text3.png" />
        </div>
      </transition>
      <transition name="fade">
        <div class="show-text2 text9" v-show="show9">
          <img src="@/assets/2/text4.png" />
        </div>
      </transition>
    </div>
    <!-- 太空人 -->
    <div class="yu">
      <img src="@/assets/2/yu.png" class="yuImg animated fadeIn" v-if="yu" />
    </div>
    <!-- 画面3 -->
    <div v-if="hua3">
      <img src="@/assets/3/bg.png" class="bg3 animated fadeInUp" />
      <img src="@/assets/3/yu.png" class="hua3-yu animated fadeInLeft" />
      <img src="@/assets/3/img1.png" class="hua3-img1 animated lightSpeedIn" />
      <img src="@/assets/3/img2.png" class="hua3-img2 animated lightSpeedIn" />
      <img
        src="@/assets/3/img3.png"
        class="hua3-img3 animated tada"
        @click="toTimu"
      />
    </div>
    <!-- 向上标签 -->
    <img src="@/assets/1/fan.png" class="fan" v-show="!hua3" />
  </div>
</template>
<script>
var wx = require("weixin-js-sdk");
import minxin from "@/mixins/index.js"; // 引入minixn
export default {
  mixins: [minxin],
  data() {
    return {
      text1: true,
      text2: false,
      showImg: true,
      bg: true,
      icon: true,
      hua3: false,
      lx2State: false,
      lx3State: false,
      lx4State: false,
      lx5State: false,
      lx6State: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      show8: false,
      show9: false,
      kuang: false,
      yu: false,
      xing: true,
      touchStatus: 0,
    };
  },
  mounted() {
    this.autoPlayAudio();
    this.getWechatConfig();
    // // 播放音乐
    //  this.autoPlayAudio();
    setInterval(() => {
      this.icon = !this.icon;
    }, 300);
    setInterval(() => {
      this.xing = !this.xing;
    }, 800);
    //   setInterval(() => {
    //   this.bg = !this.bg;
    // }, 2000);
    this.liuxing();
    setTimeout(() => {
      this.word1();
    }, 1000);
    // this.word2();
  },
  methods: {
    vueTouch: function (txt, e) {
      if (this.touchStatus == 0) {
        this.touchStatus = 1;
        this.wordHide();
      } else if (this.touchStatus == 1) {
        this.touchStatus = 2;
        this.wordHide2();
      } else {
        this.wordHide2();
      }
    },
    autoPlayAudio() {
      var globalAudio = document.getElementById("cheerMusic");
      globalAudio.play();
      wx.config({
        // 配置信息, 即使不正确也能使用 wx.ready
        debug: false,
        appId: "",
        timestamp: 1,
        nonceStr: "",
        signature: "",
        jsApiList: [],
      });
      wx.ready(function () {
        var globalAudio = document.getElementById("cheerMusic");
        globalAudio.play();
      });
    },
    // autoPlayAudio() {
    //     wx.config({
    //         // 配置信息, 即使不正确也能使用 wx.ready
    //         debug: false,
    //         appId: '',
    //         timestamp: 1,
    //         nonceStr: '',
    //         signature: '',
    //         jsApiList: []
    //     });
    //     wx.ready(function() {
    //         var globalAudio=document.getElementById("cheerMusic");
    //         globalAudio.play();
    //     });
    // },
    liuxing() {
      setTimeout(() => {
        this.lx2State = true;
      }, 2000);
      setTimeout(() => {
        this.lx3State = true;
      }, 2500);
      setTimeout(() => {
        this.lx4State = true;
      }, 8000);
      setTimeout(() => {
        this.lx5State = true;
      }, 4000);
      setTimeout(() => {
        this.lx6State = true;
      }, 7000);
      setInterval(() => {
        this.$nextTick(() => {
          this.lx2State = false;
          this.lx3State = false;
        });
      }, 3000);
      setInterval(() => {
        this.$nextTick(() => {
          this.lx4State = false;
          this.lx5State = false;
          this.lx6State = false;
        });
      }, 3000);
      setInterval(() => {
        this.lx2State = true;
        this.lx3State = true;
      }, 4000);
      setInterval(() => {
        this.lx4State = true;
        this.lx5State = true;
        this.lx6State = true;
      }, 2000);
    },
    wordHide() {
      this.text1 = false;
      this.text2 = true;
      this.word2();
    },
    wordHide2() {
      this.text2 = false;
      this.yu = false;
      this.hua();
    },
    hua() {
      this.hua3 = true;
    },
    word1() {
      setTimeout(() => {
        this.show1 = true;
      }, 500);
      setTimeout(() => {
        this.show2 = true;
      }, 2500);
      setTimeout(() => {
        this.show3 = true;
      }, 4500);
      setTimeout(() => {
        this.show4 = true;
      }, 6500);
      setTimeout(() => {
        this.show5 = true;
      }, 8500);
      setTimeout(() => {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.showImg = false;
      }, 10500);
      setTimeout(() => {
        if (this.touchStatus == 0) {
          this.word2();
        }
        this.touchStatus == 1;
      }, 11500);
    },
    word2() {
      this.text2 = true;
      setTimeout(() => {
        this.kuang = true;
        this.show6 = true;
        this.yu = true;
      }, 500);
      setTimeout(() => {
        this.show6 = false;
        this.show7 = true;
      }, 4500);
      setTimeout(() => {
        this.show7 = false;
        this.show8 = true;
      }, 8500);
      setTimeout(() => {
        this.show8 = false;
        this.show9 = true;
      }, 10500);
      setTimeout(() => {
        this.show8 = false;
        this.show9 = false;
        this.hua3 = true;
        this.kuang = false;
        this.yu = false;
      }, 14500);
      setTimeout(() => {
        this.hua3 = true;
      }, 15500);
    },
    toTimu() {
      this.$router.push("/timu");
    },
  },
};
</script>
<style lang="less" scoped>
.icon-div {
  position: relative;
  width: 100%;
  height: 200px;
}
.icon {
  position: absolute;
  bottom: auto;
  right: 5%;
  left: auto;
  top: 5%;
  width: 11vw;
  display: initial;
  z-index: 2;
  clear: both;
}
#home {
  position: relative;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  opacity: 0;
}
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.bgImg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
}
.bgImg2 {
  animation-duration: 1s; /*动画时间*/
  animation-fill-mode: both; /*播放后的状态*/
  animation-iteration-count: infinite; /*动作循环的次数：infinite 无限循环*/
  animation-duration: 2s; /*动画时间*/
  animation-name: huang; /*动画的名称*/
  transform-origin: center bottom; /*设置动画旋转元素的基点为：居中靠下*/
}
.xing {
  top: 30%;
  right: 0;
  height: auto;
}
// 流星
.liuxing {
  width: 100vw;
  height: 100vh;
  position: relative;
  .lx {
    opacity: 0;
    position: absolute;
  }
  .lx1 {
    width: (13.8125rem/2) /* 221/16 */;
    height: (9.1875rem/2) /* 147/16 */;
    .bg("./img/p1-liuxing0.png");
    left: (1.875rem/2) /* 30/16 */;
    top: (31.25rem/2) /* 500/16 */;
    animation: lx1dong 5s linear;
  }

  .lx2 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: (3.125rem/2) /* 50/16 */;
    top: -(3.125rem/2) /* 50/16 */;
    animation: lx1dong 4s linear;
  }

  .lx3 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 150px;
    top: 10px;
    animation: lx3dong 5s linear;
  }

  .lx4 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 0;
    top: 300px;
    animation: lx1dong 4s linear;
  }

  .lx5 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: -100px;
    top: -80px;
    animation: lx3dong 3s linear;
  }

  .lx6 {
    width: (30.5rem/2) /* 488/16 */;
    height: (20.25rem/2) /* 324/16 */;
    .bg("./img/p1-liuxing1.png");
    left: 150px;
    top: 350px;
    animation: lx3dong 2s linear;
  }
}
@keyframes lx1dong {
  0% {
    transform: translate(-100px, 0);
    opacity: 1;
  }
  100% {
    transform: translate(750px, 600px);
    opacity: 1;
  }
}
// 文字
.top-img {
  width: 80%;
  position: absolute;
  top: 13vh;
  left: 10%;
}
.top-img img {
  width: 100%;
}
.show-text {
  position: absolute;
  top: 32vh;
  width: 100vw;
  left: 0;
}
.text2 {
  top: 38vh;
}
.text3 {
  top: 50vh;
}
.text4 {
  top: 56vh;
}
.text5 {
  top: 62vh;
}
.show-text img {
  width: 100%;
}
.kuang {
  position: absolute;
  top: 13%;
  width: 80%;
  left: 10%;
}
// 文字2
.show-text2 {
  position: absolute;
  left: 15%;
  width: 70%;
  top: 22%;
}
.show-text2 img {
  width: 100%;
}
.text7 {
  width: 60%;
  left: 20%;
}
.text8 {
  width: 20%;
  left: 40%;
  top: 27%;
}
.text9 {
  width: 56%;
  left: 22%;
  top: 23%;
}
// 宇航员
.yu {
  position: absolute;
  bottom: 20%;
  right: 0;
  width: 70%;
}
.yuImg {
  width: 100%;
  position: relative;
  animation: mymove 5s infinite;
  -webkit-animation: mymove 5s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 5s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
// 上下晃动
@keyframes huang {
  0%,
  100%,
  20%,
  50%,
  80% {
    transition-timing-function: cubic-bezier(
      0.215,
      0.61,
      0.355,
      1
    ); /*贝塞尔曲线 ： X1 Y1 X2 Y2*/
    transform: translate3d(0, 0, 0); /*设置只在Z轴上移动*/
  }
  40%,
  43% {
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    transform: translate3d(10px, -10px, 0);
  }
  70% {
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(5px, -5px, 0);
  }
  90% {
    transform: translate3d(1px, -1px, 0);
  }
}
// 画面3
.bg3 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}
.hua3-yu {
  position: absolute;
  bottom: 15%;
  right: 0;
  width: 20%;
  left: 40%;
  animation-delay: 1s;
  -webkit-animation-delay: 1s; /* Safari 和 Chrome */
}
.hua3-img1,
.hua3-img2 {
  position: absolute;
  width: 80%;
  left: 10%;
  top: 10%;
}
.hua3-img2 {
  top: 20%;
  width: 60%;
  left: 30%;
}
.hua3-img3 {
  position: absolute;
  width: 40%;
  left: 30%;
  bottom: 10%;
  animation: pulse 1.5s infinite;
}
.fan {
  position: absolute;
  bottom: 4vw;
  width: 10%;
  left: 45%;
  animation: post-list-row 1.5s ease 1s infinite;
  -webkit-animation: post-list-row 1.5s ease 1s infinite;
  //  animation-iteration-count: infinite;
  //  animation-duration: 2s; /*动画时间*/
  //  animation-name:shang; /*动画的名称*/
  // transform-origin: center bottom; /*设置动画旋转元素的基点为：居中靠下*/
}
@keyframes post-list-row {
  0% {
    opacity: 0;
    -webkit-transform: translateY(25px);
    transform: translateY(25px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0) scale(0.9);
  }
}
@-webkit-keyframes post-list-row {
  0% {
    opacity: 0;
    -webkit-transform: translateY(25px);
    transform: translateY(25px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0) scale(0.9);
  }
}
@keyframes shang {
  0%,
  100%,
  20%,
  50%,
  80% {
    transition-timing-function: cubic-bezier(
      0.215,
      0.61,
      0.355,
      1
    ); /*贝塞尔曲线 ： X1 Y1 X2 Y2*/
    transform: translate3d(0, 0, 0); /*设置只在Z轴上移动*/
  }
  40%,
  43% {
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    transform: translate3d(0, -15px, 0);
  }
  70% {
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -8px, 0);
  }
  90% {
    transform: translate3d(0, -1px, 0);
  }
}
@keyframes pulse {
  0% {
    transform: scaleX(1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scaleX(1);
  }
}
.delay1 {
  animation-delay: 1s;
  -webkit-animation-delay: 1s; /* Safari 和 Chrome */
}
.delay2 {
  animation-delay: 2s;
  -webkit-animation-delay: 2s; /* Safari 和 Chrome */
}
.delay3 {
  animation-delay: 3s;
  -webkit-animation-delay: 3s; /* Safari 和 Chrome */
}
.delay4 {
  animation-delay: 4s;
  -webkit-animation-delay: 4s; /* Safari 和 Chrome */
}
.delay5 {
  animation-delay: 5s;
  -webkit-animation-delay: 5s; /* Safari 和 Chrome */
}
.delay6 {
  animation-delay: 6s;
  -webkit-animation-delay: 6s; /* Safari 和 Chrome */
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue